import {Injectable} from '@angular/core';

@Injectable()
export class UnassociatedService {

  private progress : number = 0;

  public setProgress(progress:number){
    this.progress = progress;
  }
  public getProgress(){
    return this.progress;
  }
}



// WEBPACK FOOTER //
// ./src/providers/unassociated.service.ts